"use client"
import {
  defineSuspense
} from "./chunk-IHYSFXDI.js";
import {
  SuspenseDefaultPropsContext
} from "./chunk-PJ6VIZI5.js";

// src/Suspense.tsx
import { useContext } from "react";
import { jsx } from "react/jsx-runtime";
var Suspense = ({ clientOnly, children, fallback }) => {
  const defaultProps = useContext(SuspenseDefaultPropsContext);
  const DefinedSuspense = defineSuspense({
    defaultPropsClientOnly: defaultProps.clientOnly,
    componentPropsClientOnly: clientOnly
  });
  return /* @__PURE__ */ jsx(DefinedSuspense, { fallback: fallback === void 0 ? defaultProps.fallback : fallback, children });
};
if (process.env.NODE_ENV === "development") {
  Suspense.displayName = "Suspense";
}

export {
  Suspense
};
//# sourceMappingURL=chunk-AJGA4FR4.js.map